// Libraries
var React = require('react');

// Components
var CallToAction = require('../../common/CallToAction/CallToAction');

// Styles
require('./QuickLinksModule.scss');
var chevronSvg = require('images/chevron.svg');

class QuickLinksModule extends React.Component {
	render() {
		return (
			<nav className="QuickLinks" aria-label="Quick Links">
				<div className="QuickLinks__inner">
					{!this.props.data.showIWCClock &&
						<span className="QuickLinks__title">{this.props.data.title}</span>
					}
					{this.props.data.linksList &&
						<ul className="QuickLinks__lists">
							{this.props.data.linksList.map((link, i) => {
								return(
									<li key={link.caption + i}>
										<CallToAction button={false} {...link} linkStyle="secondary" />
									</li>
								);
							})}
						</ul>
					}
				</div>
			</nav>
		);
	}
}

module.exports = QuickLinksModule;



// WEBPACK FOOTER //
// ./src/components/QuickLinks/QuickLinksModule.js